import layout0 from './layout0/Layout0Config';
import layout1 from './layout1/Layout1Config';
import layout2 from './layout2/Layout2Config';
import layout3 from './layout3/Layout3Config';

import i18next from 'i18next';
import enGB from '@locales/abslayouts/enGB';
import deAT from '@locales/abslayouts/deAT';

i18next.addResourceBundle('enGB', 'abslayouts', enGB);
i18next.addResourceBundle('deAT', 'abslayouts', deAT);

const themeLayoutConfigs = {
  layout0,
  layout1,
  layout2,
  layout3,
};

export default themeLayoutConfigs;
